import React, { Component } from 'react'
import PinterestSocial      from './PinterestSocial'
import TwitterSocial        from './TwitterSocial'
import LinkedinSocial       from './LinkedinSocial'

export default class SocialContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      activeTab:  0,
      tabs:       []
    }
  }

  componentDidMount() {
    const socialTabStart = ['twitter', 'linkedin', 'pinterest']
    let filteredTabs = socialTabStart.filter( (tab) => { 
      return this.props.social.find(({type}) => type == tab)
    })
    this.setState({tabs: filteredTabs})
  }

  changeTab(index) {
    this.setState({activeTab: index})
  }

  fetchTabClass(index) {
    if (this.state.activeTab == index) {
      return 'socialTab socialTabSelected'
    }
    return 'socialTab' 
  }

  renderSocial(socialName) {
    return (<div className='socialContent'>
      {
        this.props.social.map(({ type, url }) => {
          if (type == 'pinterest') {
            return <PinterestSocial key={url} url={url} hidden={socialName != 'pinterest'}/>
          }
          if  (type == 'twitter') {
            return <TwitterSocial key={url} url={url} hidden={socialName != 'twitter'}/>
          }
          if (type == 'linkedin') {
            return <LinkedinSocial key={url} url={url} hidden={socialName != 'linkedin'}/>
          }
        })
      }
    </div>)
  }

  render() {
    if (this.state.tabs.length == 0) {
      return null
    }

    return (
      <div className='socialColumn'>
        <div className='socialContainer'>
          <ol className='socialTabs'>
            {
              this.state.tabs.map( (tab, index) => {
                return (
                  <li key={tab} className={this.fetchTabClass(index)} onClick={this.changeTab.bind(this, index)}>
                    <img src={`/images/social/${tab}.png`} />
                  </li>
                )
              })
            }
          </ol>
          { this.state.tabs.length > 0 && this.renderSocial(this.state.tabs[this.state.activeTab]) }
        </div>
      </div>
    )
  }
}

SocialContainer.defaultProps = {
  social:      []
}


// WEBPACK FOOTER //
// client/components/social/SocialContainer.js